import { Injectable, inject } from '@angular/core';
import { retry, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, map, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IAuthTokenResponse } from '../../interfaces/auth/auth-token-response';
import { ISessionDetails } from '../../interfaces/session-details';
import { ISubaccountSpec } from '../../interfaces/account/subaccount-spec';
import { INotificationHistory } from '../../interfaces/notification/notification-history';
import { INotificationHistoryResponse } from '../../interfaces/notification/notification-history-response';
import { SharedService } from '../shared.service';
// import { DataExchangeService } from '../../services/data-exchange.service';
// import { Buffer } from 'buffer';
import { PageElementSpec } from '../../classes/page-element-spec';
import { NGXLogger } from 'ngx-logger';

const SCOPE = 'mobills-portal ei-blond'; // ei-blond to make the token expire in one minute
const GRANT_TYPE = 'client_credentials';

@Injectable({
  providedIn: 'root'
})
export class WalPageService {

  // private basicAuth = environment.settings.auth; 
  private readonly authTokenUrl = environment.settings.authUrl + '/token'; 
  private readonly sessionDetailsUrl = '/ui-pages/payload/session';
  private readonly notificationHistoryUrl = '/ui-pages/payload/notif-hist';
  private readonly subaccountsUrl = '/subaccounts/{brandCode}/{serialNumber}/specs';
  private readonly extraViewItemsUrl = '/ui-pages/payload/extra-view-items';
  private readonly logger = inject(NGXLogger);

  constructor(
    private readonly http: HttpClient,    
    private readonly sharedService: SharedService   
  ) { }

  public getTempAuthToken (): Observable<IAuthTokenResponse> {
    // Find out client id and secret
    // const delimiter = ':';
    // const result = this.splitString(decodedString, delimiter);
    // const clientId = result?.firstPart;
    // const clientSecret = result?.secondPart;
    // Make a call tto AuthServer to get an auth token
    let headers = new HttpHeaders()
      // .set('Authorization', this.basicAuth)
      .set('Content-Type', 'application/x-www-form-urlencoded');
    let tokenRquestUrl = this.authTokenUrl;  
    // let body = `grant_type=${GRANT_TYPE}&username=${clientId}&password=${clientSecret}&scope=${SCOPE}`;
    let body = `grant_type=${GRANT_TYPE}&scope=${SCOPE}`;
    // console.log('getAuthToken', tokenRquestUrl);
    return this.http.post<IAuthTokenResponse>(tokenRquestUrl, body, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  public getSessionDetails(region: string, sessionId: string, source?: string): Observable<ISessionDetails> {
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.sessionDetailsUrl;

    let headers = new HttpHeaders()
      .set("request-origin", "csr-portal")
      .set('session-id', sessionId);
      // .set('source', source ? source : '');
      // console.log('getSessionDetails - headers', headers);
    return this.http.get<ISessionDetails>(url, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  public getNotificationLog(region: string, sessionId: string): Observable<INotificationHistoryResponse> {
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.notificationHistoryUrl;
    let headers = new HttpHeaders()
      .set("request-origin", "csr-portal")
      .set('session-id', sessionId);
      // console.log('getNotificationHistory - url', url);
    return this.http.get<INotificationHistoryResponse>(url, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  public getSubaccounts(region: string, sessionId: string, brandCode: string, serialNumber: string): Observable<ISubaccountSpec[]> {
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.subaccountsUrl
      .replace('{brandCode}', brandCode)
      .replace('{serialNumber}', serialNumber);
    let headers = new HttpHeaders()
      .set("request-origin", "csr-portal")
      .set('session-id', sessionId);
    // console.log('getSubaccounts - url', url);
    return this.http.get<ISubaccountSpec[]>(url, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  geExtraViewItems(region: string, sessionId: string, brandCode: string, serialNumber: string): Observable<PageElementSpec<any>[]> {
    let baseUrl = this.sharedService.getBaseUrlByRegion(region);
    let url = baseUrl + this.extraViewItemsUrl
      .replace('{brandCode}', brandCode)
      .replace('{serialNumber}', serialNumber);
    let headers = new HttpHeaders()
      .set("request-origin", "csr-portal")
      .set('session-id', sessionId);
    return this.http.get<any[]>(url, {headers: headers, responseType: 'json'}).pipe(
      map(raw => {
        let data: any;
        try {
          data = typeof raw === 'string' ? JSON.parse(raw) : raw;
        } catch (e) {
          console.error('Failed to parse API response:', e);
          return [];
        }
        if (Array.isArray(data)) {
          return data.map(item => new PageElementSpec<any>(item));
        } else {
          console.error('Unexpected API response format:', data);
          return [];
        }
      })
    );
  }  

  // private decodeString(base64String: string): string {
  //   base64String = base64String.replace('Basic ',''); 
  //   const decodedString = Buffer.from(base64String, 'base64').toString('utf-8');
  //   return decodedString;
  // }

  // private splitString(input: string, delimiter: string): { firstPart: string, secondPart: string } | null {
  //   const delimiterIndex = input.indexOf(delimiter);
  //   if (delimiterIndex === -1) {
  //     return null;
  //   }
  //   const firstPart = input.substring(0, delimiterIndex);
  //   const secondPart = input.substring(delimiterIndex + delimiter.length);
  //   return { firstPart, secondPart };
  // }

}
